// УДЕРЖАНИЕ ЭКРАНА НА ВРЕМЯ ЗАПИСИ (Screen Wake Lock). Строка 82, тикет `3fe19875cbb8815fa603c554d4f98519`.
//
// Зачем: автоблокировка iOS гасит экран посреди записи, а при блокировке iOS отбирает у Safari микрофон и
// усыпляет таймеры (проход 19.10: экран гаснет через ~1 мин; 16.10 авто-стоп по тишине не сработал).
// `navigator.wakeLock.request('screen')` есть в Safari с iOS 16.4.
//
// ⭐ Берётся ВНУТРИ ЖЕСТА: Safari iOS без активации пользователя отказывает (`NotAllowedError: Permission was denied`),
// а касание пальцем даёт активацию только на `pointerup`/`click`, не на `pointerdown` (замер cc-221, симулятор iOS 26.5).
// Поэтому `hold()` зовётся и на нажатии, и на отпускании; повтор безвреден. Отпускается, когда голос вернулся в покой. Браузер сам снимает удержание, если вкладку свернули, — на возврате (`visibilitychange`)
// поднимаем снова, пока удержание нужно.
// ⛔ Нет API, отказ, ошибка — тихо без удержания: запись от него не зависит. Вида и текстов нет.

/**
 * @param {{ env?: object }} [opts] — `env` подменяется тестом (navigator, document)
 * @returns {{ hold(): void, release(): void, destroy(): void }}
 */
export function createScreenHold({ env = globalThis } = {}) {
  const api = env?.navigator?.wakeLock;
  const doc = env?.document;
  let wanted = false;
  let sentinel = null;

  // ⚠️ Запросы НЕ сериализуются флагом «в пути»: отказ на `pointerdown` ещё не вернулся, когда приходит `pointerup` с
  // активацией, — флаг пропустил бы именно тот запрос, который Safari выдаёт (гонка поймана тестом шага 3, cc-221).
  // Лишнее удержание (пришло второе, или уже не нужно) отпускается сразу.
  async function acquire() {
    if (!api?.request || sentinel) return;
    if (doc && doc.visibilityState && doc.visibilityState !== 'visible') return;
    try {
      const s = await api.request('screen');
      if (!wanted || sentinel) { s?.release?.()?.catch?.(() => {}); return; }
      sentinel = s;
      s?.addEventListener?.('release', () => { if (sentinel === s) sentinel = null; });
    } catch {
      /* отказ / нет активации — без удержания */
    }
  }

  function drop() {
    const s = sentinel;
    sentinel = null;
    try { s?.release?.()?.catch?.(() => {}); } catch { /* уже снято */ }
  }

  const onVisible = () => { if (wanted && doc?.visibilityState === 'visible') acquire(); };
  doc?.addEventListener?.('visibilitychange', onVisible);

  return {
    hold() { wanted = true; acquire(); },
    release() { wanted = false; drop(); },
    destroy() { wanted = false; drop(); doc?.removeEventListener?.('visibilitychange', onVisible); },
  };
}
